export const getAuthBaseUrl = (): string | undefined => {
  return window.API_CONFIG?.api.auth?.baseUrl;
};
